import React, { useEffect, useState } from "react";
import CompleteFamilySetupStep1 from "./CompleteFamilySetupStep1";
import CompleteFamilySetupStep2 from "./CompleteFamilySetupStep2";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import moment from "moment-timezone";
import { InactiveUserPopup } from "../../InactiveUserPopup";

const CompleteFamilySetup: React.FunctionComponent = (props: any) => {
    const dispatch = useDispatch();
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const subcustomerID = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.childSubcustomerIdToCompleteAccount ? state.loggedInUser.childSubcustomerIdToCompleteAccount : ""
    );
    const childDOBToCompleteAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.childDOBToCompleteAccount ? state.loggedInUser.childDOBToCompleteAccount : ""
    );
    const accountToSwitch = familyMembers.find((x) => x.subcustomerId === subcustomerID);
    const dob =
        accountToSwitch && accountToSwitch.dateOfBirth
            ? moment(accountToSwitch.dateOfBirth).format("MM/DD/YYYY")
            : childDOBToCompleteAccount
            ? childDOBToCompleteAccount
            : "";
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [state, setState] = useState({
        firstName: accountToSwitch && accountToSwitch.firstName ? accountToSwitch.firstName : "",
        lastName: accountToSwitch && accountToSwitch.lastName ? accountToSwitch.lastName : "",
        middleName: "",
        SSN: "",
        confirmSSN: "",
        driversLicense: "",
        DOB: dob,
        passport: "",
        medicalInsurance: "",
        mothersMaidenName: "",
        userID: accountToSwitch && accountToSwitch.userId ? accountToSwitch.userId : "",
        step: 1,
    });

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <InactiveUserPopup {...props} />
            <div className="row middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        Complete {state.firstName}'s Setup
                    </h1>
                </div>
            </div>
            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <i className="las la-user"></i>
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Personal Information {state.step} of 2</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <div role="grid" className="data-grid">
                                    <div role="row" className="data-row row">
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" id="label-personal-information-details">
                                                <p>For maximum protection, add as much information as possible.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            {state.step === 1 && (
                                <CompleteFamilySetupStep1 dob={state.DOB} state={state} firstName={state.firstName} lastName={state.lastName} setState={setState} />
                            )}
                            {state.step === 2 && <CompleteFamilySetupStep2 history={props.history} state={state} setState={setState} />}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompleteFamilySetup;
